import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../../common/AutoBindComponent";
import LinkOrganisatiePageHelper from "./LinkOrganisatiePageHelper";
import LinkOrganisatieForm from "./LinkOrganisatieForm";
import LinkOrganisatieFilterForm from "./LinkOrganisatieFilterForm";
import * as layoutActions from "../../../actions/layoutActions";
import * as sessionActions from "../../../actions/sessionActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";
import Form from "../../common/Form";
import * as types from "../../../constants/ComponentConstants";
import redirector from "../../../util/redirector";

class LinkOrganisatiePage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            searchModel: {
                naam: "",
                afkorting: "",
                ondernemingsnummer: "",
                telefoon: "",
                email: "",
                website: ""
            },
            errors: {},
            validationMessageType: '',
            sportclubs: [],
            totalSearchResult: -1,
            modalIsOpen: false,
            modalSportclub: null,
            nameFilterHasFocus: true
        };

        this.pageHelper = new LinkOrganisatiePageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.props.setHasUnsavedChanges(false);
        this.pageHelper.init();
    };

    handleOnCancel = () => this.pageHelper.cancel();

    handleOnSearch = () => this.pageHelper.search();

    handleOnChange = (event) => this.pageHelper.change(event);

    handleOnAddSportclub = (id) => this.pageHelper.addSportclub(id);

    handleOpenModal = (id) => this.pageHelper.openModal(id);

    handleCloseModal = () => this.pageHelper.closeModal();

    handleCreateNew = () => this.pageHelper.createNew();

    render() {
        const state = this.state;
        const headerStyle = { 'color': '#006fB7', 'fontSize': '44px', 'textAlign': 'center', 'fontWeight': '500', 'padding': '0px', 'margin': '0px', 'backgroundColor': 'white', 'minHeight': '91.2px', 'paddingTop': '7px' };

        return (
            <Fragment>
                <div style={headerStyle}>{this.props.federatieNaam}</div>
                <Section
                    title={"Sportclub melden"}
                    color={types.COLOR_BLUE}>
                    <Fieldset>
                        <Form name="sportclub melden"
                            headerVisible={false}
                            isNotRequired
                        >
                            <LinkOrganisatieFilterForm
                                onCancel={this.handleOnCancel}
                                onSearch={this.handleOnSearch}
                                onChange={this.handleOnChange}
                                searchModel={state.searchModel}
                                errors={state.errors}
                                validationMessageType={this.setState.validationMessageType}
                                onAddSportclub={this.handleOnAddSportclub}
                                modalIsOpen={state.modalIsOpen}
                                modalSportclub={state.modalSportclub}
                                onCloseModal={this.handleCloseModal}
                                nameFilterHasFocus={state.nameFilterHasFocus}
                            />
                            <LinkOrganisatieForm
                                searchModel={this.state.searchModel}
                                sportclubs={this.state.sportclubs}
                                totalSearchResult={this.state.totalSearchResult}
                                onOpenModal={this.handleOpenModal}
                                onCreateNew={this.handleCreateNew}
                            />
                        </Form>
                    </Fieldset>
                </Section>
            </Fragment>

        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        federatieId: state.security.currentOrganisationInfo.id,
        federatieNaam: state.security.currentOrganisationInfo.naam,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        setActiveSportclub: bindActionCreators(sessionActions.setActiveSportclubId, dispatch),
        loadOverzichtLayout: bindActionCreators(layoutActions.loadOverzichtPageLayout, dispatch),
        setSearchModel: bindActionCreators(sessionActions.setSportclubSearchModel, dispatch),
        setHasUnsavedChanges: bindActionCreators(sessionActions.setHasUnsavedChanges, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkOrganisatiePage);